const adminExpoRouter = [
  {
    path: '/admin/e',
    name: 'AdminExpoIndex',
    component: () => import('@/views/admin/expo/index')
  },
  {
    path: '/admin/e/create',
    name: 'AdminExpoCreate',
    component: () => import('@/views/admin/expo/create')
  },
  {
    path: '/admin/e/edit',
    name: 'AdminExpoEdit',
    component: () => import('@/views/admin/expo/edit')
  },
  {
    path: '/admin/e/tag',
    name: 'AdminExpoTag',
    component: () => import('@/views/admin/expo/tag')
  },
  {
    path: '/admin/e/join',
    name: 'AdminExpoJoin',
    component: () => import('@/views/admin/expo/join')
  },
  {
    path: '/admin/e/guest',
    name: 'AdminExpoGuest',
    component: () => import('@/views/admin/expo/guest')
  },
  {
    path: '/admin/e/cert',
    name: 'AdminExpoCert',
    component: () => import('@/views/admin/expo/cert')
  },
  {
    path: '/admin/e/cg',
    name: 'AdminExpoCg',
    component: () => import('@/views/admin/expo/cg')
  },
  {
    path: '/admin/e/ep',
    name: 'AdminExpoEpIndex',
    component: () => import('@/views/admin/expo/ep/index')
  },
  {
    path: '/admin/e/ep/stat',
    name: 'AdminExpoEpStat',
    component: () => import('@/views/admin/expo/ep/stat')
  },
  {
    path: '/admin/e/ep/export',
    name: 'AdminExpoEpExport',
    component: () => import('@/views/admin/expo/ep/export')
  }
]

export default adminExpoRouter



// WEBPACK FOOTER //
// ./src/router/modules/admin/expo.js